import { createApp } from "vue"
import FunTipsDialog from "./logIn.vue"
import vue3GoogleLogin from "vue3-google-login"
import { createI18nInstance, registerI18n } from "@/i18n/i18n.js"
import { getCookie } from "@/utils/cookie.js"
import GlobalConfig, { chinaAppName } from "@/config/config.js";

let isLogInShow = false

export default function LogIn(options) {
  // 创建一个节点，并将组件挂载上去
  if (isLogInShow) return
  isLogInShow = true
  const mountNode = document.createElement("div")
  document.body.appendChild(mountNode)
  const app = createApp(FunTipsDialog, {
    ...options,
    visible: true,
    remove() {
      isLogInShow = false
      app.unmount(mountNode) //创建完后要进行销毁
      document.body.removeChild(mountNode)
    },
  })
  app.config.globalProperties = {
    ...(window?.$getVueCurrentInstance()?.appContext?.config?.globalProperties ?? {}),
    ...app.config.globalProperties,
  }
  app.use(vue3GoogleLogin, {
    clientId: "1069642802272-0ktgtg6hn72ljht0bltd9h14qseflsvj.apps.googleusercontent.com",
    scope: "profile email",
  })
  return app.mount(mountNode)
}
